import { Turbo } from '@hotwired/turbo-rails';

Turbo.StreamActions.enable = function () {
  const target = this.targetElements[0];
  target.disabled = false;
};
